import { useHistory } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../contexts/userContext';
import Cookies from 'js-cookie';
import i18next from 'i18next';

import Navi1 from './icons/question-icon.svg';
import Navi2 from './icons/shopping-icon.svg';
import Navi3 from './icons/home-icon.svg';
import Back from './icons/back-icon.svg';
import Forward from './icons/forward-icon.svg';
import Logo from './icons/travel wifi logo.svg';
import FAQ from './FAQ/FAQ';

import { languages } from '../../staticData/languages';

function NaviBar(props) {
  const history = useHistory();
  const { stat, setStat } = useContext(UserContext);
  const { cart, setShowCart, langs } = props;

  const EURO_FLAG = localStorage.getItem('EURO_FLAG') === 'TRUE';
  const machineData = JSON.parse(localStorage.getItem('machine'));
  let machineID = machineData?._id;
  let machineLanguage = machineData?.languages ? machineData?.languages : [];

  if (machineLanguage) {
    machineLanguage = machineLanguage.map((i) => i.code);
  }

  const lanOptions = languages.filter((item) => machineLanguage.includes(item.code));

  // machineLanguage.forEach((element) => {
  //   const index = languages.findIndex((e) => e.code === element);
  //   if (index > -1) {
  //     lanOptions.push(languages[index]);
  //   }
  // });

  const home = () => {
    history.push(`/machineUI/homePage/${machineID}`);
  };

  const forward = () => {
    history.goForward();
  };

  const goBack = () => {
    if (!window.location.href.includes('homePage')) {
      history.goBack();
    }
  };

  const [curr, setCurr] = useState([]);
  const [rest, setRest] = useState([]);
  const [show, setShow] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);

  const setShowTrue = () => {
    show ? setShow(false) : setShow(true);
  };

  const showFAQfunc = () => {
    showFAQ ? setShowFAQ(false) : setShowFAQ(true);
  };

  const clickCart = () => {
    if (cart && cart.length > 0) {
      setShowCart(true);
    }
  };

  useEffect(() => {
    if (showFAQ) {
      console.log('stat', stat);
      stat.faq = stat.faq += 1;
      setStat(stat);
    }
  }, [showFAQ]);

  useEffect(() => {
    const currentLan = Cookies.get('i18next') || languages[0].name;
    const findindex = lanOptions.findIndex((e) => e.code === currentLan);
    if (findindex > -1) {
      setCurr(lanOptions[findindex]);
      const copy = [...lanOptions];

      if (EURO_FLAG) {
        copy.forEach((e) => {
          e.image = e.image2;
        });
      }

      const newRest = copy.splice(findindex, 1);

      setRest(copy);
    }
    // console.log('crr', lanOptions[findindex]);
  }, []);

  const selectLanguage = async (index) => {
    rest.push(curr);
    const newCurr = rest.splice(index, 1);
    if (newCurr[0]?.code === 'en') {
      console.log('22');
      stat.language.en = stat.language.en += 1;
    }
    if (newCurr[0]?.code === 'fr') {
      stat.language.fr = stat.language.fr += 1;
    }
    if (newCurr[0]?.code === 'es') {
      stat.language.es = stat.language.es += 1;
    }

    setRest([...rest]);
    setCurr(newCurr[0]);
    setShow(false);

    setStat(stat);
    props.setlangs(newCurr[0].code);
    await i18next.changeLanguage(newCurr[0].code);
  };

  const restLanguage = rest.map((e, i) => {
    return (
      <div
        className="langauge-resetLan"
        key={i}
        onClick={() => {
          selectLanguage(i);
        }}
      >
        <img alt="" src={`/Icons/${e.image}`} className="navi-icon language-other-icon"></img>
        <div className="language-other-text">{e.name}</div>
      </div>
    );
  });

  return (
    <div className="navi-bar">
      <FAQ show={showFAQ} setShow={setShowFAQ} langs={langs} />
      <div className="language-div" onClick={setShowTrue}>
        <img alt="" src={`/Icons/${curr?.image}`} className="navi-icon"></img>
      </div>
      {show && <div className="langauge-resetLan-container">{restLanguage}</div>}
      <img src={Navi1} className="navi-icon" alt="" onClick={showFAQfunc}></img>
      <img src={Navi3} className="navi-icon" alt="" onClick={home}></img>
      <div className="home-logo-div">
        <img src={Logo} className="home-logo" alt=""></img>
      </div>
      <img src={Back} className="navi-icon" alt="" onClick={goBack}></img>
      <img src={Forward} className="navi-icon" alt="" onClick={forward}></img>
      <img src={Navi2} className="navi-icon" alt="" onClick={clickCart}></img>
    </div>
  );
}
export default NaviBar;
